import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import Main from './pages/Main'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<Main />)

reportWebVitals()
